<template>
  <dd-input-wrapper :rules="rules"  :title="title">
      <div class="btn-group radio-group flex-row multi-switch" ref="self">
          <slot></slot>
      </div>
  </dd-input-wrapper>
</template>

<script>
export default {
  name: "DdMultiSwitch",
  emits: ['input'],
  props: {
    rules: {
      type: [String, Array],
      required: false
    },
    title: {
      type: String,
      required: false
    },
    groupName: {
      type: String,
      required: false
    },
  },
  provide(){
    return {
      groupName: this.groupName,
    };
  },
  methods:{
    onRadioButtonClick(radio) {
      this.$emit('input', radio.value);
    }
  },
  mounted() {
    this.radioButtons = this.$refs.self.getElementsByClassName('radio-input');
    for(let radio of this.radioButtons) {
      radio.addEventListener('click', () => this.onRadioButtonClick(radio))
    }
  },
}
</script>

